require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projects-aol-reader-ios.json") })
        }
      }, "path---projects-aol-reader-ios");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---projects-aol-reader-ios!./.cache/json/projects-aol-reader-ios.json
// module id = 355
// module chunks = 231608221292675